var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 0.320068C8.07641 0.320068 7.48 0.916475 7.48 1.64007V2.96007H1.32C0.592969 2.96007 0 3.55304 0 4.28007V10.0001C0 10.7271 0.592969 11.3201 1.32 11.3201H20.68C21.407 11.3201 22 10.7271 22 10.0001V4.28007C22 3.55304 21.407 2.96007 20.68 2.96007H14.52V1.64007C14.52 0.916475 13.9236 0.320068 13.2 0.320068H8.8ZM8.8 1.20007H13.2C13.4475 1.20007 13.64 1.39257 13.64 1.64007V2.96007H8.36V1.64007C8.36 1.39257 8.5525 1.20007 8.8 1.20007ZM11 8.68007C11.4864 8.68007 11.88 9.07366 11.88 9.56007C11.88 10.0465 11.4864 10.4401 11 10.4401C10.5136 10.4401 10.12 10.0465 10.12 9.56007C10.12 9.07366 10.5136 8.68007 11 8.68007ZM0 10.8801V18.3601C0 19.0871 0.592969 19.6801 1.32 19.6801H20.68C21.407 19.6801 22 19.0871 22 18.3601V10.8801C22 11.6071 21.407 12.2001 20.68 12.2001H1.32C0.592969 12.2001 0 11.6071 0 10.8801Z",
    fill: "#1C64F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.ba72e0ee4e12fdbbcb03969fb54abf40.svg";
export { ForwardRef as ReactComponent };